import React from 'react';
import { Outlet } from 'react-router-dom';
import './Layout.scss';

const Layout: React.FC = () => {
    return (
        <div className="layout">
            <Outlet />
        </div>
    );
};

export default Layout;
